export class RestoreAtlasClusterInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "clusterName",
            "baseName": "clusterName",
            "type": "string",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "allowExistingCluster",
            "baseName": "allowExistingCluster",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "databasePrefix",
            "baseName": "databasePrefix",
            "type": "string",
            "format": ""
        },
        {
            "name": "databaseFilter",
            "baseName": "databaseFilter",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "collectionFilter",
            "baseName": "collectionFilter",
            "type": "{ [key: string]: Array<string>; }",
            "format": ""
        },
        {
            "name": "overProvisionedInstanceSize",
            "baseName": "overProvisionedInstanceSize",
            "type": "string",
            "format": ""
        },
        {
            "name": "overProvisionedDiskIops",
            "baseName": "overProvisionedDiskIops",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "shardingMode",
            "baseName": "shardingMode",
            "type": "RestoreAtlasClusterInputShardingModeEnum",
            "format": ""
        },
        {
            "name": "numShards",
            "baseName": "numShards",
            "type": "number",
            "format": ""
        },
        {
            "name": "forceCdcBinCompaction",
            "baseName": "forceCdcBinCompaction",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "compactionMinCdcBinsOverride",
            "baseName": "compactionMinCdcBinsOverride",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAtlasClusterInput.attributeTypeMap;
    }
    constructor() {
    }
}
export var RestoreAtlasClusterInputShardingModeEnum;
(function (RestoreAtlasClusterInputShardingModeEnum) {
    RestoreAtlasClusterInputShardingModeEnum["Auto"] = "auto";
    RestoreAtlasClusterInputShardingModeEnum["Skip"] = "skip";
})(RestoreAtlasClusterInputShardingModeEnum || (RestoreAtlasClusterInputShardingModeEnum = {}));
